import * as React from 'react';
import FittextCore from './fittext-core';
const Fittext = (props) => {
    return (React.createElement(FittextCore, Object.assign({}, props)));
};
export default Fittext;
